import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getPlansData,
  getTestimonials,
  getBrowsePhotos,
  getStatus,
  getLanguages,
  getAddOnData,
} from "../store/slices/HomeSlice";

export const useHome = () => {
  const dispatch = useDispatch();
  const { availableLanguage, plansData,AddOnData,AddOnStatus,testimonialData, browsePhotosData, liveStatusData ,status} =
    useSelector((state) => state.home);

  const plans = (renew) => {
    dispatch(getPlansData(renew));
  };
  const AddOnPlans = () => {
    dispatch(getAddOnData());
  };

  const testimonials = () => {
    if (testimonialData == undefined) {
      dispatch(getTestimonials());
    }
  };

  const browsePhotos = () => {
    // dispatch(getBrowsePhotos());
  };

  const liveStatus = () => {
    if (liveStatusData == undefined) {
      dispatch(getStatus());
    }
  };
  return {
    plansData,
    testimonialData,
    browsePhotosData,
    liveStatusData,
    status,
    plans,
    testimonials,
    browsePhotos,
    liveStatus,
    AddOnData,
    AddOnPlans,
    availableLanguage,
    AddOnStatus
  };
};
